import { PageOption, TileActions } from "components/dynamic-content/util/dynamicContent"
import { Asset, Entry } from "contentful"
import { ICalendlyLink, ITalkToCarrotCountry, ITalkToCarrotSendAMessage, ITile, ITilePage } from "contentful-types"
import slugify from "slugify"

enum TileNextActionType {
  TILE_PAGE = "tilePage",
  CALENDLY_LINK = "calendlyLink",
  TALK_TO_CARROT_SEND_A_MESSAGE = "talkToCarrotSendAMessage"
}

const getTileTitle = (tile: ITile): string => {
  if (fieldIsValid(tile)) {
    const {
      fields: { display }
    } = tile
    if (fieldIsValid(display)) {
      const {
        fields: { title }
      } = display
      return title
    }
  }
  return null
}
const fieldIsValid = (entry: Entry<any>) => {
  return entry && entry.sys.type !== "Link"
}

const getPathForTile = ({ tile, baseUrl }: { tile: ITile; baseUrl: string }): string => {
  const title = getTileTitle(tile)
  const slug = title ? slugify(title).toLowerCase() : "unknown"
  return `${baseUrl}/${slug}`
}

const getNextTileAction = (tile: ITile): ITilePage | ICalendlyLink | ITalkToCarrotSendAMessage => {
  const {
    fields: { nextAction }
  } = tile
  return nextAction
}

const getNextActionType = (nextAction: ITilePage | ICalendlyLink | ITalkToCarrotSendAMessage): TileNextActionType => {
  const {
    sys: {
      contentType: {
        sys: { id }
      }
    }
  } = nextAction
  return Object.values(TileNextActionType).find((type) => type == id)
}
const getIconUrl = (icon: Asset) => {
  if (icon) {
    const {
      fields: { file }
    } = icon
    return file ? file.url : null
  }
  return null
}

const getTileOnClick = ({ tile, actions, baseUrl }: { tile: ITile; actions: TileActions; baseUrl: string }) => {
  const { gotoPageAction, openCalendlyAction } = actions
  const nextAction = getNextTileAction(tile)
  if (fieldIsValid(nextAction)) {
    switch (getNextActionType(nextAction)) {
      case TileNextActionType.TILE_PAGE:
        return () => gotoPageAction(getPathForTile({ tile, baseUrl }))
      case TileNextActionType.CALENDLY_LINK:
        const {
          fields: { url }
        } = nextAction as ICalendlyLink
        return () => openCalendlyAction(url)
      case TileNextActionType.TALK_TO_CARROT_SEND_A_MESSAGE:
        return () => gotoPageAction(getPathForTile({ tile, baseUrl }))
    }
  } else {
    return () => gotoPageAction("/404")
  }
}
const getTTCLocationOption = ({ fields: { country, page } }: ITalkToCarrotCountry): PageOption => {
  if (fieldIsValid(country) && fieldIsValid(page)) {
    const {
      fields: { name, alpha2CountryCode }
    } = country
    const {
      sys: { id }
    } = page
    return {
      slug: slugify(name).toLowerCase(),
      label: name,
      value: alpha2CountryCode,
      pageId: id
    }
  } else {
    return null
  }
}

export {
  TileNextActionType,
  getTileTitle,
  getPathForTile,
  fieldIsValid,
  getNextTileAction,
  getIconUrl,
  getNextActionType,
  getTileOnClick,
  getTTCLocationOption
}
